import { useCallback, useEffect, useRef } from 'react';
import API from '@api';
const useCheckIsPaidInteval = ({ orderId, successCallback }) => {
  const interval = useRef();

  const clear = () => {
    clearInterval(interval.current);
    interval.current = null;
  };

  const checkIsPaidFunc = useCallback(() => {
    if (orderId) {
      API.checkOrderPaid({
        id: +orderId
      }).then(res => {
        if (res.checkOrderPaid) {
          successCallback && successCallback();
        }
      });
    }
  }, [orderId, successCallback]);

  useEffect(() => {
    interval.current = setInterval(checkIsPaidFunc, 5000);
    return () => clear();
  }, [checkIsPaidFunc]);
};

export default useCheckIsPaidInteval;
